<template lang="pug">
a.Link._flexInline._mb1._ls-05._c-grey-700(:href="`#${anchorId}`")
   ._mr075(:id="anchorId") {{heading}}
   //- .HeadingIcon-anchor: include /icons/icon-link.svg
</template>

<style lang="sass">
.HeadingIcon-anchor
   svg 
      width: 16px
      display: inherit
      .primary
         fill: $grey-200
      .secondary
         // fill: $light-blue-vivid-200
         fill: $grey-200
.Link
   text-decoration: none
   &:hover
      .HeadingIcon-anchor svg
         .primary
            fill: $grey-400
         .secondary
            fill: $light-blue-vivid-500
</style>

<script>
import { makeCamelCase } from '~/util.js'
export default {
   name: 'AccountPanelHeading',
   props: {
      heading: String,
   },
   data() {
      const headingCamelCased = makeCamelCase(this.heading)
      return {
         anchorId: `section-${headingCamelCased}`,
      }
   },
}
</script>
